"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownGroupedItemList = _interopRequireDefault(require("./item-lists/DropdownGroupedItemList"));

var _DropdownItemList = _interopRequireDefault(require("./item-lists/DropdownItemList"));

function isGrouped(items) {
  var _items$;

  return Object.prototype.hasOwnProperty.call((_items$ = items[0]) !== null && _items$ !== void 0 ? _items$ : {}, 'groupName');
}

var DropdownList = function DropdownList(_ref) {
  var type = _ref.type,
      align = _ref.align,
      items = _ref.items,
      displayListUpwards = _ref.displayListUpwards,
      hasSearch = _ref.hasSearch,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      searchPlaceholderText = _ref.searchPlaceholderText,
      searchIconWidth = _ref.searchIconWidth,
      searchIconHeight = _ref.searchIconHeight,
      _ref$customItem = _ref.customItem,
      customItem = _ref$customItem === void 0 ? null : _ref$customItem,
      hideEmptyGroup = _ref.hideEmptyGroup;
  if (!isOpen) return null;
  var classes = (0, _classnames.default)('control-dropdown__list', type ? "control-dropdown__list--".concat(type) : null, "control-dropdown__list--".concat(align), displayListUpwards ? 'control-dropdown__list--up' : null);
  var hasDecorator = hasSearch || customItem;
  if (!items.length && !hasDecorator) return null;

  if (isGrouped(items)) {
    return (0, _preact.h)(_DropdownGroupedItemList.default, {
      hideEmptyGroup: hideEmptyGroup,
      items: items,
      classes: classes,
      customItem: customItem
    });
  }

  return (0, _preact.h)(_DropdownItemList.default, {
    items: items,
    classes: classes,
    hasSearch: hasSearch,
    searchPlaceholderText: searchPlaceholderText,
    searchIconWidth: searchIconWidth,
    searchIconHeight: searchIconHeight,
    customItem: customItem
  });
};

var _default = DropdownList;
exports.default = _default;